<template>
  <div :id="hashId" class="historyChart"></div>
</template>

<script>
  import * as echarts from 'echarts'
  export default {
    props: {
      id: {
        type: String,
        required: false,
        default: undefined
      },
      chartDatas: {
        type: Object
      }
    },
    data() {
      return {
        chartData: undefined,
        hashId: this.id ? this.id : _.uniqueId('chart_')
      }
    },
    created() {
      this.debounceResize = _.debounce(this.resize, 200)
      window.addEventListener('resize', _ => {
        this.debounceResize()
      })
    },
    mounted() {
      this.createChart()
    },
    methods: {
      resize() {
        try {
          this.chartData.resize()
        } catch (e) {
          console.log(e)
        }
      },
      createChart() {
        if (this.chartData) this.chartData.dispose()
        this.chartData = echarts.init(document.querySelector('#' + this.hashId))
        let option = {
          tooltip: {},
          grid: {
            top: '10%',
            left: '5%',
            right: '8%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              color: '#cccccc',
              data: this.chartDatas.categories,
              axisLabel: {
                rotate: 40,
                color: '#cccccc',
                textStyle: {
                  fontSize: 12
                }
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(62, 74, 100, 0.5)'
                }
              },
              axisTick: {
                show: false
              }
            }
          ],
          yAxis: [
            {
              splitLine: {
                lineStyle: {
                  width: 1,
                  color: 'rgba(62, 74, 100, 0.5)'
                }
              },
              axisLabel: {
                color: '#cccccc',
                textStyle: {
                  fontSize: 12
                }
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(62, 74, 100, 0.5)'
                }
              },
              axisTick: {
                show: false
              }
            }
          ],
          series: [
            {
              type: 'line',
              data: this.chartDatas.seriesData,
              type: 'line',
              symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
              showAllSymbol: true,
              smooth: true,
              symbolSize: 8,
              lineStyle: {
                normal: {
                  color: '#35b9f7' // 线条颜色
                },
                borderColor: 'rgba(0,0,0,.4)'
              },
              itemStyle: {
                color: '#35b9f7',
                borderColor: '#35b9f7',
                fontSize: 12,
                borderWidth: 2
              },
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  formatter: [' {a|{c}}'].join(','),
                  rich: {
                    a: {
                      color: '#cccccc',
                      align: 'center'
                    }
                  }
                }
              },
              tooltip: {
                show: true
              },
              areaStyle: {
                //区域填充样式
                normal: {
                  opacity: 0.8,
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: '#35b9f7'
                      },
                      {
                        offset: 1,
                        color: '#232b46'
                      }
                    ],
                    false
                  )
                }
              }
            }
          ]
        }
        this.chartData.setOption(option)
      }
    },
    watch: {
      chartDatas: {
        deep: true,
        handler: function() {
          this.createChart()
        }
      }
    },
    destroyed() {
      if (this.chartData) this.chartData.dispose()
    }
  }
</script>

<style lang="less" scoped>
  .historyChart {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/lv2/appMonitor/switchDetail/simpleChart.vue